import "@mantine/core/styles.css";
import { useTheme } from "@/shared/theme/useTheme";
import Spinner from "@/shared/ui/spinner/Spinner";
import { MantineProvider } from "@mantine/core";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";

import i18n from "../i18n";
import { ErrorBoundary } from "../shared/ui/errorBoundary";
import { AppRoutes } from "./AppRoutes";
import '@mantine/charts/styles.css';

import { persistStore } from "@entities/StepFolder/store/persistStore";

export default function AppRouter() {
	const theme = useTheme();
	console.log("theme", theme);

	return (
		<MantineProvider defaultColorScheme="dark" theme={theme}>
			<BrowserRouter>
				<ErrorBoundary>
					<Suspense fallback={<Spinner />}>
						<I18nextProvider i18n={i18n}>
							<AppRoutes />
						</I18nextProvider>
					</Suspense>
				</ErrorBoundary>
			</BrowserRouter>
		</MantineProvider>
	);
}
